import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";

export interface ITrack {
  id: string;
  title: string;
  isrc: string;
  artist: string;
  types: string;
  releases_count: number;
}

export interface IFilters {
  filterArtistIds?: string[];
  filterLabelIds?: string[];
  trackTitle?: string;
  isrc?: string;
}

export const useTracks = (
  currentPage: number = 0,
  pageCount: number = 5,
  filterArtistIds: IFilters['filterArtistIds'],
  filterLabelIds: IFilters['filterLabelIds'],
  trackTitle: IFilters['trackTitle'],
  isrc: IFilters['isrc'],
) => {
  const [tracks, setTracks] = React.useState<ITrack[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const [total, setTotal] = React.useState(0);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => {
      await getTracks(currentPage, pageCount, {
        filterArtistIds,
        filterLabelIds,
        trackTitle,
        isrc,
      });
    })();
  }, [currentPage, pageCount, filterArtistIds, filterLabelIds, trackTitle, isrc]);
  

  const getTracks = async (
    currentPage: number = 0,
    pageCount: number = 5,
    filters: IFilters,
  ) => {
    try {
      setFetching(true);
      const queryParams = new URLSearchParams({
        page: currentPage,
        per_page: pageCount,
        artist_ids: prepareFilter('artist_ids', filters.filterArtistIds),
        title: filters.trackTitle,
        label_id: filters.filterLabelIds?.length ? filters.filterLabelIds[0] : '', // prepareFilter('label_id', filters.filterLabelIds),
        isrc: filters.isrc,
      } as any);
      const query = Array.from(queryParams.entries())
        .map(param => {
          if (param[1]) {
            return `${param[0]}=${param[1]}`;
          }
          return '';
        })
        .filter(param => !!param)
        .join('&');
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.Tracks}?${query}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setTracks(response.data.data);
      setTotal(response.data.meta.total);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  return { tracks, total, fetching, getTracks };
};

const prepareFilter = (key: string, ids?: string[]) => {
  return ids?.length ? ids.map(id => `${key}[]=${id}`).join("&") : '';
};
